var catDescription = $(".woocommerce-Tabs-panel--description");

if(catDescription.length > 0) {
    var catDescriptionLength = [];
    var totalLength = 0;
    
    $(".woocommerce-Tabs-panel--description").each(function () {
        var $this = $(this);
        var catDescriptionHeight = $this.height();
        
        if(catDescriptionHeight > 600) {
            catDescription.addClass('category-description--long');
            catDescription.append('<button id="category-toggle">Lire la suite</button>')
        }
    });
}

$('#category-toggle').click(function() {
    $(this).toggleClass('opened');
    $(this).parent().toggleClass('description-opened');
})